var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_139_4865)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2861 80.3571C37.0183 71.8929 45.2147 65.1964 54.7504 61.2321C46.4468 55.0179 41.0361 45.1071 41.0361 33.9643C41.0361 15.2143 56.2504 0 75.0004 0C93.7504 0 108.965 15.2143 108.965 33.9643C108.965 45.1071 103.554 55.0179 95.2504 61.2321C104.84 65.1964 112.983 71.8929 118.715 80.3571H31.2861Z",
    fill: "#00A90B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150 101.782V133.925C150 142.818 142.821 149.997 133.929 149.997H16.0714C7.17857 149.997 0 142.818 0 133.925V101.782C0 92.8895 7.17857 85.7109 16.0714 85.7109H133.929C142.821 85.7109 150 92.8895 150 101.782ZM63.375 123.211H76.6071V128.943C76.6071 131.89 79.0179 134.3 81.9643 134.3C84.9107 134.3 87.3214 131.89 87.3214 128.943V123.211H93.2679V128.943C93.2679 131.89 95.6786 134.3 98.625 134.3C101.571 134.3 103.982 131.89 103.982 128.943V123.211H112.5C115.446 123.211 117.857 120.8 117.857 117.854C117.857 114.907 115.446 112.497 112.5 112.497H63.375C61.1786 106.282 55.2321 101.782 48.2143 101.782C39.3214 101.782 32.1429 108.961 32.1429 117.854C32.1429 126.747 39.3214 133.925 48.2143 133.925C55.1786 133.925 61.1786 129.425 63.375 123.211ZM48.2143 112.497C51.1607 112.497 53.5714 114.907 53.5714 117.854C53.5714 120.8 51.1607 123.211 48.2143 123.211C45.2679 123.211 42.8571 120.8 42.8571 117.854C42.8571 114.907 45.2679 112.497 48.2143 112.497Z",
    fill: "#00A90B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_139_4865",
    x: 0,
    y: 0,
    width: 150,
    height: 154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_139_4865"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.47c5b9971c83053e16b455aa8bcc2dfb.svg";
export { ForwardRef as ReactComponent };